import React from 'react';
// import {withRouter} from 'react-router-dom';
import BurgerIngredient from './BurgerIngredient/BurgerIngredient';
import classes from './Burger.module.css';

const burger = (props) => {
    let transformedIngredients = Object.keys(props.ingredients)
    .map(igKey => {
        return [...Array(props.ingredients[igKey])].map((_ , i) => {
            return <BurgerIngredient key={igKey + i} type={igKey} />
        })
    })
    .reduce((arr, el) => {
        return arr.concat(el)
    }, [])
    if(transformedIngredients.length === 0){
        transformedIngredients = <p style={{color: '#703809', textTransform: 'capitalize'}}>Let's add some Ingredients</p>
    }
    return (
        <div className={classes.Burger}>
            <BurgerIngredient type='bread-top' />
            {transformedIngredients}
            <BurgerIngredient type='bread-bottom' />
        </div>
    )
}

export default burger;


// WEBPACK FOOTER //
// ./src/components/Burger/Burger.js